const FRONTEND_RELOAD_PARAM = "_canucci_reload";

export function createFrontendReloadUrl(currentUrl: string, cacheBuster: string | number = Date.now()): string {
  const url = new URL(currentUrl);
  url.searchParams.set(FRONTEND_RELOAD_PARAM, String(cacheBuster));
  return url.toString();
}

export function createCleanFrontendUrl(currentUrl: string): string | null {
  const url = new URL(currentUrl);
  if (!url.searchParams.has(FRONTEND_RELOAD_PARAM)) return null;

  url.searchParams.delete(FRONTEND_RELOAD_PARAM);
  return `${url.pathname}${url.search}${url.hash}`;
}

export function hardReloadFrontend(): void {
  window.location.replace(createFrontendReloadUrl(window.location.href));
}
